export default {"src":"/_next/static/media/ruby_logo_fa52d2c016.f7a03204.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};